module.exports = __webpack_public_path__ + "img/Brazil_states.24ee35a5.svg";